import { render, staticRenderFns } from "./WeekSingle.vue?vue&type=template&id=3154c890&scoped=true"
import script from "./WeekSingle.vue?vue&type=script&lang=js"
export * from "./WeekSingle.vue?vue&type=script&lang=js"
import style0 from "./WeekSingle.vue?vue&type=style&index=0&id=3154c890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3154c890",
  null
  
)

export default component.exports